import React from "react";
import logo from "../../assets/GP-Logo-1.png";
import { BsTwitter } from "react-icons/bs";
import { FaDiscord } from "react-icons/fa";
function Nav(props) {
  return (
    <div className="flex w-full absolute top-[60px] z-10 items-center md:px-[120px] md:justify-between">
      <div className="items-center hidden md:flex">
        <img src={logo} className="w-[70px] md:w-[90px]" alt="" />
        <h1 className="text-white font-black text-xl md:text-2xl">Gele</h1>
      </div>
      <div className="flex w-full justify-around  md:w-2/3 lg:w-1/3 md:justify-between">
        <BsTwitter
          className="social-media-icon hover:bg-white transition ease-in-out duration-500 "
          size={40}
        />
        <FaDiscord
          className="social-media-icon hover:bg-white transition ease-in-out duration-500"
          size={40}
        />
        {/* <button className="btn bg-black hover:bg-[#6c77ea] transition ease-in-out duration-300 text-white py-[6px] px-[20px] ">
          Connect with wallet
        </button> */}
        <div class="max-w-[200px] flex items-center justify-center text-white max-h-[60px] rounded-sm py-[3px] px-[2px] button-custom">
          <div class="w-full h-full cursor-pointer text-white font-bold text-sm rounded-sm px-[10px] py-[6px] bg-[#0d0d0d]">
            Connect with wallet
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nav;
